import React from "react";

import { AgentConfigure } from "./AgentConfigure";

/** Creating an agent is the same screen as configuring one, starting from a blank draft. */
const CreateAgent: React.FC = () => <AgentConfigure creating />;

export default CreateAgent;
